document.addEventListener("DOMContentLoaded", function () {
  const redirectUrl = localStorage.getItem("redirect");
  const body = document.querySelector("body");

  if (redirectUrl) {
    console.log("Redirecting to:", redirectUrl);

    if (window.location.pathname === "/cart") {
      // Fetch cart and save preview before redirect
      fetch("/cart.json")
        .then(response => response.json())
        .then(cart => {
          if (cart.items && cart.items.length > 0) {
            const firstItem = cart.items[0];
            const previewImage = firstItem.properties?.Preview || "";
            const tagType = firstItem.properties?.["Select Tags Type"] || "";

            if (previewImage) {
              localStorage.setItem("cartPreviewImage", previewImage);
              localStorage.setItem("tagType", tagType);
              console.log("Saved preview image:", previewImage);
            }
          }

          // Remove redirect key and then redirect
          localStorage.removeItem("redirect");
          window.location.href = redirectUrl;
        })
        .catch(err => {
          console.error("Failed to fetch cart JSON:", err);
          // Even if fetch fails, remove key and redirect
          localStorage.removeItem("redirect");
          window.location.href = redirectUrl;
        });
    } else {
      // Not on cart page → just redirect
      localStorage.removeItem("redirect");
      window.location.href = redirectUrl;
    }
  } else {
    // No redirect → show cart
    body.classList.remove("hide_cart");
  }
});
